

<section class="main-content wrapper content-padding " style="margin-top: 50px;">
    <div class="content-panel">

        <div class="tabs">
            <label class="tab">
                <a class="tab-link active-tab">INVOICES</a>
            </label>
        </div>

        
        <div class="button-wrapper">
            <!--
            <ng-template [ngIf]="selected == 'active'">
                <a class="btn hvr-grow has-margin-right" 
                    [routerLink]="['/expert/receipts/storico']"
                    [queryParamsHandling]="'merge'"
                >
                    <i class="mr-10 far fa-folder"></i>Storico
                </a>
            </ng-template>
        
            <ng-template [ngIf]="selected == 'inactive'">
                <button class="btn hvr-grow has-margin-right" 
                    [routerLink]="['../']"
                    [queryParams]="{ navigation: 'back' }"
                    [queryParamsHandling]="'merge'"
                >
                    <i class="mr-10 fas fa-arrow-left"></i>Ritorna
                </button>
            </ng-template>
            -->
        </div>       

        <p class="valet-name">
            <b>
                PARTNER
                <span *ngIf="selectedPartnerId"> | {{ selectedPartner?.businessName?.toUpperCase() }}</span>
            </b>
        </p>

        <div class="button-wrapper">
            <div class="grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <label for="sku">PARTNERS</label>
                <select [(ngModel)]="selectedPartnerId" (ngModelChange)="handlePartnerChange($event)" id="selezionePartner">
                    <option [ngValue]="null" disabled selected>Select Partner</option>
                    <option *ngFor="let partner of partners" [ngValue]="partner.id">{{ partner?.businessName }}</option>
                </select>
            </div>
        </div>

        <div class="column-box">
            <ng-container *ngIf="invoices?.length > 0; else noInvoices">
                <div class="column-inner-other-user" *ngFor="let invoice of invoices; index as i"
                    [ngClass]="{
                        'status-created-border': invoice?.invoiceStatus?.toLowerCase() === 'peding',
                        'status-approved-border': invoice?.invoiceStatus?.toLowerCase() === 'overdue',
                        'status-paid-border': invoice?.invoiceStatus?.toLowerCase() === 'paid'
                    }">
                    <div class="card-container" (click)="toggleAccordion(i)">
                        <div class="action-btns" 
                            [ngClass]="{
                                'status-created': invoice?.invoiceStatus?.toLowerCase() === 'peding',
                                'status-approved': invoice?.invoiceStatus?.toLowerCase() === 'overdue',
                                'status-paid': invoice?.invoiceStatus?.toLowerCase() === 'paid'
                            }">
                            <div class="action-title">
                                <h3 class="invoice-header">
                                    <b>ID INVOICE: #{{ invoice?.id }}</b>
                                    <b>INVOICE DATE: {{ invoice?.createdAt | date:'MMMM d, y - h:mm a' }}</b>
                                </h3>
                            </div>
                            <div class="action-icons">
                                
                                <!-- <i 
                                    matTooltip="Confermata" 
                                    *ngIf="(invoice.receiptStatus === 'open') && (selected === 'active') && (groups.includes('admin') || groups.includes('operation'))" (click)="handleApproveClick(invoice, $event)" class="material-icons action-icon" style="color: #4CAF50;">
                                    check_circle
                                </i>
                                <i 
                                    matTooltip="Paid" 
                                    *ngIf="(invoice.receiptStatus === 'approved') && (selected === 'active') && (groups.includes('admin') || groups.includes('operation'))" (click)="handlePaidClick(invoice, $event)" class="material-icons action-icon" style="color: #009688;">
                                    payments
                                </i> -->

                                <i 
                                    matTooltip="partner invoice" 
                                    *ngIf="invoice.invoiceUrl" 
                                    (click)="openInvoice(invoice.invoiceUrl)" 
                                    class="material-icons action-icon" 
                                    style="color: #3f51b5; cursor: pointer;">
                                    receipt_long
                                </i>
                            
                                <i class="material-icons" [ngClass]="{'rotate-icon': true, 'active': activeAccordionActivityIndex === i}">expand_more</i>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-body" *ngIf="activeAccordionActivityIndex === i">
                        <ng-container *ngIf="invoice.deliveryInvoiceDeliveries.length > 0">
                            <div class="info-container" *ngFor="let deliveryInvoiceDelivery of invoice.deliveryInvoiceDeliveries">
                                <div class="event-name">Consegna #{{ deliveryInvoiceDelivery.delivery?.id }}</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-template #noInvoices>
                <span>NO INVOICES YET FOR {{ selectedPartner?.businessName?.toUpperCase() }}...</span>
            </ng-template>
        </div>
    </div>
</section>
